import dayjs from "dayjs";
import isoWeek from "dayjs/plugin/isoWeek";

dayjs.extend(isoWeek);

export interface WeekDates {
  week_start: string;
  week_end: string;
}

export interface AttendanceType {
  attendance_id: string;
  user_id: string;
  employee_name: string;
  employee_code: string;
  month: number;
  year: number;
  date: string;
  present_days: number;
  paid_leaves: number;
  sick_leaves: number;
  leave_without_pay: number;
  late_marks: number;
  overtime_hours: number;
  regularized_days: number;
  created_at: string;
  week_number: number;
  week_dates: WeekDates;
}

export interface AttendanceSummaryType {
  total_late_marks: number;
  total_overtime: number;
  total_regularized_days: number;
  avg_late_marks: number;
  avg_overtime: number;
  week_number: number;
  year: number;
  week_start: string;
  week_end: string;
}

export interface AttendanceResponseType {
  results: AttendanceType[];
  summary: AttendanceSummaryType;
}

export const initialAttendanceState: AttendanceType = {
  attendance_id: '',
  user_id: '',
  employee_name: '',
  employee_code: '',
  month: dayjs().month() + 1,
  year: dayjs().year(),
  date: dayjs().format('YYYY-MM-DD'),
  present_days: 0,
  paid_leaves: 0,
  sick_leaves: 0,
  leave_without_pay: 0,
  late_marks: 0,
  overtime_hours: 0,
  regularized_days: 0,
  created_at: dayjs().format(),
  week_number: dayjs().isoWeek(),
  week_dates: {
    week_start: '',
    week_end: ''
  }
};